<script>
  import { DialogNew, Icon } from '@shopboxai/sb-portal-components';
  import { clientID } from '../../../utils';
  export let data;
  let rows = 2,
    currency = 'EUR';

  $: code = `
  <script async src="https://grid.shopbox.ai/sbgrid.min.js"></\script>
  <div style="--sb-rows: ${rows}; min-height: calc(240px * var(--sb-rows));">
     <shopbox-grid cid="${$clientID}" currency="${currency}" id="${data}"></shopbox-grid>
  </div>
  `;
</script>

<DialogNew data={code} on:submit on:close>
  <div slot="header">Embed code</div>
  <div slot="content">
    <label for="">Currency</label>
    <input type="text" bind:value={currency} />
    <label for="">Number of Rows</label>
    <input type="number" bind:value={rows} />
    <label for=""> Code</label>
    <textarea value={code} />
  </div>
  <button class="primary" slot="primary-action">Copy code</button>
  <button slot="toggle"><Icon name="code" /></button>
</DialogNew>

<style>textarea{border:1px solid #ddd;font-size:17px;height:240px;width:100%}</style>
